<template>
  <div>
    <el-page-header @back="goBack" content=""> </el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>名称：</span>
          <span class="glay">{{ appInfo.appName }}({{ appInfo.appTypeName }})</span>
        </div>
        <div class="pub-line">
          <span>应用ID：</span>
          <span class="glay">{{ appInfo.appid }}</span>
        </div>
        <div style="margin-top: 30px">
          <span>渠道：</span>
          <span>
            <el-tag
              :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
              v-for="(item, index) in getChannel"
              :key="index"
              @click="activeEvent(index, item.channelAccountId)"
              effect="plain"
              style="margin-bottom: 10px"
              >{{ item.channelTypeName }} ( {{ item.account }} - {{item.code}} )</el-tag
            >
          </span>
        </div>

        <div style="margin-top: 30px">
          <span>广告位：</span>
          <span>
            <el-tag
              style="margin-bottom:10px;"
              :class="{ 'tag-marr': true, 'active-bg1': navIndex == index }"
              v-for="(item, index) in getAdversing"
              :key="index"
              @click="activeEventNav(index, item.adSite)"
              effect="plain"
              type="danger"
              >{{ item.name }}</el-tag>
          </span>
        </div>

        <div style="margin-top: 30px">
          <el-button
            type="primary"
            plain
            size="medium"
            @click="handleselectTopic"

            :disabled="isEmpty(getChannel) || isEmpty(getAdversing) ? true : false"

            >添加广告</el-button
          >
        </div>
        <div style="margin-top: 30px">
          <div class="public-table-data">
            <el-table
              ref="multipleTable"
              :data="tableData"
              border
              style="width: 100%"
              row-key="menuId"
              v-loading="loading"
            >
              >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="expireTime"
                label="有效期"
                min-width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="eventTypeName"
                label="事件"
                width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="examId"
                label="状态"
                width="120"
                align="center"
                ><template slot-scope="scope">
                  {{
                    scope.row.status == 1
                      ? "启用"
                      : scope.row.status == 0
                      ? "禁用"
                      : scope.row.status
                  }}
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                align="center"
                width="180"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleClick('del', scope.row)"
                    type="warning"
                    plain
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      width="1195px"
      title="选择测评题"
      :visible.sync="innerVisible"
      append-to-body
      :close-on-click-modal="false"
    >
      <selectAdversing @childByValue="childByValue" />
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="innerVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleTopicList"
          >确 定</el-button
        >
      </span>
    </el-dialog>

  </div>
</template>
<script>
import selectAdversing from "./components/selectAdversing.vue";
import { ossUpload } from "@utils/filters/upload";
import { isEmpty } from "../../utils/tools/index";

export default {
  components: {
    selectAdversing,
  },
  data() {
    return {
      isEmpty,
      appInfo: {},
      getChannel: [],
      getAdversing: [],
      tagIndex: 0,
      navIndex: 0,
      innerVisible: false,
      dialogVisible: false,
      tableData: [],
      loading: false,
      params: {},
      app: {},
      adInfoIds: [],
      srcList: [],
      isMoer: true,
      srcListLang: [],
      isMoerLang: true,
      srcListVideo: "",
      isMoerVideo: true,
      srcListBanner: [],
      dialogVisibleLink: false,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }], // superscript/subscript
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ direction: "rtl" }], // text direction

              [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"], // remove formatting button
            ],
            handlers: {
              shadeBox: null,
              insertMetric: function () {
                //方法体
                alert(1);
              },
            },
          },
        },
      },
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        subject: [{ required: true, message: "请填写主题", trigger: "change" }],
        payPrice: [
          { required: true, message: "请填写支付价", trigger: "change" },
        ],
        pages: [{ required: true, message: "请填写标签", trigger: "change" }],
        privateKey: [
          { required: true, message: "请填写商户秘钥", trigger: "change" },
        ],
        domainBizId: [
          { required: true, message: "请选择回调地址", trigger: "change" },
        ],
        domainUri: [
          { required: true, message: "请填写接口地址", trigger: "change" },
        ],
      },

      checkArray:'',
    };
  },
  watch: {
    // dialogVisible() {
    //   if (this.dialogVisible == false) {
    //     this.$refs["ruleForm"].resetFields();
    //     this.params = {};
    //     this.srcList=[]
    //     this.isMoer=false
    //   }
    // },
  },
  created() {
    this.appInfo = this.$route.query;
    // this.channelData();

    this.getAreadyChannel(this.$route.query.appInfoId); //需要显示的渠道
    this.adversingData();

    this.app.appInfoId = parseInt(this.$route.query.appInfoId);

    
      this.$nextTick(() => {
        setTimeout(() => {
          this.queryTableData();
        }, 1200);
      });

  },
  methods: {

    /* 获取该app下已经关联的渠道 */
    async getAreadyChannel(appInfoId) {
      const { data: resData } = await this.$get(
        `/app/channel/list?appInfoId=${appInfoId}`,
        {
          params: {
            status: 1,
            paging: false,
          },
        }
      );
      if (resData.result != 200) return;
      if (!isEmpty(resData.data)) {
        this.getChannel = resData.data;
        this.app.channelAccountId = resData.data[0].channelAccountId;
      }
    },
    /**
     * 获取广告列表--位置
     */
    async adversingData() {
      this.loading = true;
      const { data: resData } = await this.$get("/ad/site/list", {
        params: {
          status: 1,
          paging: false,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.getAdversing = resData.data;
      this.app.adSite = resData.data[0].adSite; //初始化默认 广告位置--adSite	string
    },
    /**
     * 新增广告
     */
    async addTopicList(app, adInfoIds) {
      this.loading = true;
      const { data: resData } = await this.$post("app/ad/info", {
        ...app,
        adInfoIds: adInfoIds,
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success(resData.message);
      this.innerVisible = false;
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      if(isEmpty(this.getChannel) || isEmpty(this.getAdversing)){
        return 
      }
      // ?adSite=${this.app.adSiteId}&appInfoId=${this.app.appInfoId}&channelAccountId=${this.app.channelAccountId}
      this.loading = true;
      const { data: resData } = await this.$get(`/app/ad/list`, {
        params: this.app,
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
    },

    /**
     * 选择广告库
     */
    handleselectTopic() {
      this.innerVisible = true;
    },
    /**
     * 接收选择后的数组
     */
    childByValue(value) {
      // this.adInfoIds=value
      this.adInfoIds = [];
      let arr = value.forEach((element) => {
        this.adInfoIds.push(element.adInfoId);
      });
    },
    //确定选择的题列表
   async handleTopicList() {
     await this.addTopicList(this.app, this.adInfoIds);
     await this.queryTableData();
    },
    /**
     * 选择渠道ID-激活
     */
    activeEvent(index, channelAccountId) {
      this.tagIndex = index;
      this.app.channelAccountId = channelAccountId;
      this.queryTableData();
    },
    /**
     * 选择广告位置ID
     */
    activeEventNav(index, adSite) {
      this.navIndex = index;
      this.app.adSite = adSite;
      this.queryTableData();
    },
    /**
     * 删除
     */
    async handleClick(type, row = {}) {
      switch (type) {
        case "del":
          this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
            type: "warning",
          }).then(async () => {
            const { data: resData } = await this.$delete(`app/ad/info/${this.app.appInfoId}/${this.app.channelAccountId}/${this.app.adSite}/${row.adInfoId}`);
            if (resData.result != 200) return;
            this.queryTableData();
            this.$message.success("删除成功!");
          });
          break;
      }
    },
    
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}
.appraisal-center {
  width: 90%;
  margin: 0 auto;
}
.fonts {
  font-size: 14px;
}
.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}
.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.fl1 {
  flex: 1;
  -webkit-flex: 1;
}
.glay {
  color: #8492a6;
  i {
    font-style: normal;
    color: #f56c6c;
  }
}
.pub-line {
  margin-top: 30px;
}
.pub-marr {
  margin-top: 20px;
}
.marr {
  margin-top: 30px;
}
.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}
.subject {
  color: #8492a6;
  margin-left: 10px;
  i {
    font-style: normal;
    color: #f56c6c;
  }
}
.activeBg {
  background: #b3d8ff;
  color: #fff;
}
.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}
.diplay {
  display: inline-block;
}
.screenshot {
  display: inline-block;
  vertical-align: text-top;
}
.video-label {
  margin-right: 15px;
}
.item-add {
  margin: 15px 0;
  .el-button {
    margin-bottom: 15px;
  }
  .el-button img {
    max-height: 12px;
  }
}
.style-outer {
  background: #fff;
  float: left;
  margin: 0 20px 20px 0;
  width: 108px;
  height: 110px;
  border: 1px solid #ddd;
  cursor: pointer;
  position: relative;
  .style__font {
    line-height: 5px;
    margin: 0 0 0 10px;
  }
  .isCheck {
    position: absolute;
    top: 0;
    right: 5px;
    z-index: 2;
    .el-icon-success {
      font-size: 20px;
      color: #ddd;
    }
  }
}
</style>